import api from "./axios";

export const getBudgetPortfolio = ({ year, organizationView, period, startDate, endDate } = {}) =>
  api.get("/budget/portfolio", {
    params: {
      ...(year ? { year } : {}),
      ...(organizationView ? { organizationView } : {}),
      ...(period ? { period } : {}),
      ...(startDate ? { startDate } : {}),
      ...(endDate ? { endDate } : {}),
    },
  });

export const getUsdInrRate = (date) =>
  api.get("/budget/exchange-rate", { params: { date, from: "USD", to: "INR" } });

export const createBudgetSubmission = (body) => api.post("/budget/submissions", body);

export const updateBudgetSubmission = (id, body) => api.patch(`/budget/submissions/${id}`, body);

export const getBudgetSubmission = (id) => api.get(`/budget/submissions/${id}`);

export const getBudgetSubmissions = (params = {}) =>
  api.get("/budget/submissions", { params });

export const getBudgetSubmissionCurrent = ({ id, department, year, organizationView } = {}) =>
  api.get("/budget/submissions/current", {
    params: {
      ...(id ? { id } : {}),
      ...(department ? { department } : {}),
      ...(year ? { year } : {}),
      ...(organizationView ? { organizationView } : {}),
    },
  });

export const submitBudgetForApproval = (id, body = {}) =>
  api.post(`/budget/submissions/${id}/submit`, body);

export const approveBudgetSubmission = (id) =>
  api.post(`/budget/submissions/${id}/approve`);

export const rejectBudgetSubmission = (id, body = {}) =>
  api.post(`/budget/submissions/${id}/reject`, body);

export const reopenBudgetSubmission = (id) =>
  api.post(`/budget/submissions/${id}/reopen`);

export const getBudgetSummary = ({ year, organizationView, departmentView } = {}) =>
  api.get("/budget/summary", {
    params: {
      ...(year ? { year } : {}),
      ...(organizationView ? { organizationView } : {}),
      ...(departmentView ? { department: departmentView } : {}),
    },
  });

export const getOrgBudget = ({ year, organizationView } = {}) =>
  api.get("/budget/org-budget", {
    params: {
      ...(year ? { year } : {}),
      ...(organizationView ? { organizationView } : {}),
    },
  });

export const setOrgBudget = (body) => api.put("/budget/org-budget", body);

export const updateCommonSpend = (submissionId, body) =>
  api.patch(`/budget/submissions/${submissionId}/common-spend`, body);

export const createBudgetRemark = (submissionId, body) =>
  api.post(`/budget/submissions/${submissionId}/remarks`, body);

export const getBudgetAudit = (submissionId) =>
  api.get(`/budget/submissions/${submissionId}/audit`);
